export default __webpack_public_path__ + "static/media/premium@3x.68b0b8e7.png";